import { api } from "../api";

export class UserService {
  static async register({
    first_name,
    last_name,
    email,
    password,
    birth,
    phone_ddi,
    phone,
    cpf,
    doc_type,
  }) {
    const { data } = await api.post("/users/register", {
      first_name,
      last_name,
      email,
      doc_type,
      cpf,
      birth,
      phone_ddi,
      phone,
      password,
      password_confirmation: password,
    });
    return data;
  }

  // ---- Usuário principal ----
  static async getUserData() {
    const { data } = await api.get("/users/me");
    return data;
  }

  static async completarCadastro(formData) {
    // No v1, o completar cadastro é um PATCH no users/me
    // Mapeia campos do frontend (usr_*) para os nomes esperados pela API
    const payload = {
      first_name:
        formData.usr_first_name ||
        formData.usr_name?.split(" ")[0] ||
        formData.first_name,
      last_name:
        formData.usr_last_name ||
        formData.usr_name?.split(" ").slice(1).join(" ") ||
        formData.last_name ||
        ".",
      doc_type: formData.usr_doc_type || formData.doc_type,
      cpf: formData.usr_cpf || formData.cpf,
      birth: formData.usr_birth || formData.birth,
      phone_ddi:
        formData.phone_ddi ||
        formData.usr_phone_ddi ||
        formData.usr_ddi ||
        formData.ddi,
      phone: formData.phone || formData.usr_phone,
      gender: formData.usr_gender ?? formData.gender,
      landline_ddi: formData.landline_ddi || formData.usr_landline_ddi,
      landline: formData.landline || formData.usr_landline,
      promotional: formData.usr_promotional ?? formData.promotional,
      transactional: formData.usr_transactional ?? formData.transactional,
    };
    const { data } = await api.patch("/users/me", payload);
    return data;
  }

  static async updatePassword({ old_password, new_password }) {
    const { data } = await api.patch("/users/update-password", {
      current_password: old_password,
      password: new_password,
      password_confirmation: new_password,
    });
    return data;
  }

  // ---- Endereços ----
  static async getAddresses() {
    const { data } = await api.get("/users/addresses");
    return data;
  }

  static async createAddress(usr_id, payload) {
    // usr_id pode ser passado mas o token já autentica o user.
    // Mantendo consistência com payload
    const { data } = await api.post("/users/addresses", payload);
    return data;
  }

  static async updateAddress(add_id, payload) {
    const { data } = await api.patch(`/users/addresses/${add_id}`, payload);
    return data;
  }

  // Deprecated: use createAddress or updateAddress directly
  static async saveAddress(arg1, arg2) {
    // Mantido para retrocompatibilidade se houver outras chamadas
    let addressPayload = arg2 || {};
    if (arg1 && typeof arg1 === "object" && "usr_id" in arg1) {
      addressPayload = arg1; // legacy support
    }
    return this.createAddress(null, addressPayload);
  }

  static async deleteAddress(add_id) {
    const { data } = await api.delete(`/users/addresses/${add_id}`);
    return data;
  }

  static async setDefaultAddress(add_id) {
    const { data } = await api.post(`/users/addresses/${add_id}/set-default`);
    return data;
  }

  // ---- Métodos de pagamento ----
  static async getPaymentMethods() {
    // TODO: v1 endpoint para pagamentos se existir
    const { data } = await api.get("/users/payment-methods");
    return data;
  }

  static async deletePaymentMethod(pay_id) {
    const { data } = await api.post("/deletePaymentMethod", { pay_id });
    return data;
  }

  static async login(email, password) {
    const { data } = await api.post("/auth/login", {
      email,
      password,
      device_name: "web",
    });
    return data;
  }
}

export default UserService;
